import React from "react";

import SiteHelmet from "./SiteHelmet";
import BrowserCheck from "../BrowserCheck";
import Header from "../Header";
import Footer from "../Footer";
import Loading from "../Loading";
import PwaPrompt from "../PwaPrompt";
import Emergency from "../Emergency";
import Cookiebox from "../Cookiebox";

import LanguageContext from "./../../state/context/LanguageContext";
import getTranslations from "./../../i18n/getTranslations";
import "../../css/styles.css";

const DefaultLayout = ({ children, pageContext }) => {
  const language =
    pageContext && pageContext.language ? pageContext.language : "fr";

  // À l'activation d'un lien d'évitement : scroll vers la cible et déplacer le focus dessus
  const handleSkipLink = (e) => {
    const href = e.currentTarget.getAttribute("href")
    const id = href && href.startsWith("#") ? href.slice(1) : null
    if (!id) return
    e.preventDefault()
    e.stopPropagation()
    const target = document.getElementById(id)
    if (!target) return
    target.scrollIntoView({ behavior: "smooth" })
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1")
    // Déplacer le focus sur la cible (main ou cookiebox) pour sortir du header.
    // Délai pour passer après tout rendu / ré-enregistrement de listeners dans le header.
    const moveFocus = () => {
      if (document.getElementById(id) === target) target.focus()
    }
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(moveFocus, 50)
      })
    })
  }

  return (
    <LanguageContext.Provider
      value={{ language, translation: getTranslations(language) }}
    >
      <div 
        className="layout default-layout d-flex flex-column justify-content-between h-100 mh-100vh"
        lang={language}
      >
        <a
          href="#main-content"
          className="skip-link"
          onClick={handleSkipLink}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSkipLink(e); } }}
        >
          Aller au contenu principal
        </a>
        <a
          href="#search-mini"
          className="skip-link"
          onClick={handleSkipLink}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSkipLink(e); } }}
        >
          Aller au champ de recherche
        </a>
        <a
          href="#footer-contacts"
          className="skip-link"
          onClick={handleSkipLink}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSkipLink(e); } }}
        >
          Aller aux contacts et accès
        </a>
        <a
          href="#cookiebox"
          className="skip-link"
          onClick={handleSkipLink}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSkipLink(e); } }}
        >
          Aller à la bannière cookies
        </a>
        <SiteHelmet lang={language} />
        <BrowserCheck />
        <Loading />
        <PwaPrompt />
        {language === "fr" && <Emergency />}
        <Header />
        <main 
          id="main-content"
          className="flex-grow-1"
          role="main"
          tabIndex={-1}
        >
          {children}
        </main>
        <Footer />
        <Cookiebox />
      </div>
    </LanguageContext.Provider>
  );
};

export default DefaultLayout;
